import config from 'config'
import { Main } from 'components/masters'

import { get } from 'lodash'
import React from 'react'
import { Tabs } from 'components/layout'
import * as Page from 'containers/pages'

const publicPath = config.publicPath
const routes = [
  {
    path: `${publicPath}/awards/:id/aj-preparation-trainings`,
    exact: true,
    component: props => (
      <Main params={get(props, 'match.params', {})} {...props}>
        <Page.AwardPreparationTraining
          {...props}
          params={get(props, 'match.params', {})}
        />
      </Main>
    )
  },
  {
    path: `${publicPath}/awards/:id/files`,
    exact: true,
    component: props => (
      <Main params={get(props, 'match.params', {})} {...props}>
        <Page.AwardFiles
          {...props}
          params={get(props, 'match.params', {})}
        />
      </Main>
    )
  },
  {
    path: `${publicPath}/awards`,
    component: props => (
      <Main params={get(props, 'match.params', {})} {...props}>
        <Page.Awards
          params={get(props, 'match.params', {})}
          tabs={
            <Tabs params={get(props, 'match.params', {})} {...props} />
          }
          {...props}
        />
      </Main>
    ),
    routes: [
      {
        path: `${publicPath}/awards`,
        exact: true,
        component: props => (
          <Page.TasksAwardsOfficeSignoff {...props} />
        )
      },
      {
        path: `${publicPath}/awards/office-signoffs`,
        exact: true,
        component: props => (
          <Page.TasksAwardsOfficeSignoff {...props} />
        )
      },
      {
        path: `${publicPath}/awards/local-office-signoffs`,
        exact: true,
        component: props => (
          <Page.TasksAwardsOfficeSignoffLocally {...props} />
        )
      },
      {
        path: `${publicPath}/awards/overview`,
        exact: true,
        component: props => (
          <Page.AwardsOverview {...props} />
        )
      }
    ]
  }
]

export default routes
